import { render, staticRenderFns } from "./brandLogos.vue?vue&type=template&id=540d8432&"
import script from "./brandLogos.vue?vue&type=script&lang=js&"
export * from "./brandLogos.vue?vue&type=script&lang=js&"
import style0 from "./brandLogos.vue?vue&type=style&index=0&id=540d8432&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports